<template>
  <div class="video-player">
    <video-player
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      @play="onPlayerPlay($event)"
    ></video-player>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  props: {
    content: {
      src: "",
      poster: ""
    },
    config: {
      triggered: {},
      paused: {
        default: false
      }
    },
    muted: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.config.triggered) {
      // this.player.play();
    }
  },
  methods: {
    onPlayerPlay($event) {
      this.player.muted(false);
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      playerOptions: {
        // videojs options
        autoplay: false,
        controls: true,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: process.env.BASE_URL + this.content.src
          }
        ],
        poster: process.env.BASE_URL + this.content.poster
      }
    };
  },
  watch: {
    // muted(muted) {
    //   this.player.muted(muted);
    // }
    config(config, oldConfig) {
      if (oldConfig && !_.isEqual(config, oldConfig)) {
        if (this.config.triggered) {
          !config.paused ? this.player.pause() : this.player.play();
        }
      }
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  components: {
    videoPlayer
  }
};
</script>

<style lang="scss" scoped>
.video-player {
  position: relative;
  height: 525px;
  width: 100%;
}
</style>

<style lang="scss">
.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 0;
}
.video-js {
  width: 100% !important;
  height: 100% !important;
  background-color: transparent;
  .vjs-volume-level {
    background: $primary;
  }
  .vjs-big-play-button {
    display: none;
  }
  .vjs-control:focus:before,
  .vjs-control:hover:before,
  .vjs-control:focus {
    box-shadow: transparent;
  }
  .vjs-tech {
    background: transparent;
  }
  .vjs-control-bar {
    height: 35px;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 100px;
    left: 0;
    width: calc(100% - 160px);
    max-width: 640px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.8);
    padding-right: 120px;

    .vjs-time-control {
      display: flex;
      align-items: center;
      font-size: 13px;

      &.vjs-current-time {
        color: $primary;
      }
      &.vjs-time-divider {
        display: none;
      }
      &.vjs-duration {
        position: absolute;
        right: 80px;
        top: 0;
        color: $primary;
      }
    }
    .vjs-playback-rate {
      display: none;
      order: 1;
    }
    .vjs-play-control {
      height: 38px;
      .vjs-icon-placeholder {
        display: flex;
        align-items: center;
        height: 100%;
        &::before {
          color: $primary;
          height: auto;
          position: initial;
        }
      }
    }
    .vjs-fullscreen-control {
      display: none;
    }
    .vjs-progress-control {
      .vjs-progress-holder {
        height: 2px;
        .vjs-load-progress {
          div {
            background: $primary;
            height: 50%;
          }
        }
        .vjs-play-progress {
          background: $primary;
          &::before {
            content: "";
          }
        }
      }
    }
    .vjs-volume-panel {
      position: absolute;
      right: 0;
      bottom: 0;
      height: 47px;
      display: flex;
      align-items: center;
      color: $primary;
      &.vjs-volume-panel-horizontal {
        width: 8em;
      }
      .vjs-mute-control {
        padding: 0;
        height: 18px;
      }
      .vjs-volume-control {
        width: 5em;
        opacity: 1;
        top: 5.5px;
        height: 30px;
        transform: translateX(-12px);
      }
      .vjs-volume-level {
        &::before {
        }
      }
    }
  }
}
@media (max-width: 1100px) {
  .video-js {
    .vjs-control-bar {
      width: 300px;
      // .vjs-time-control {
      //   &.vjs-duration {
      //     right: auto;
      //     left: 70px;
      //     &::before {
      //       content: "/";
      //     }
      //   }
      // }
    }

    // .vjs-progress-control {
    //   display: none;
    // }
  }
}
</style>
